/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react'
import PropTypes from 'prop-types'
import {Box, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useIntl, FormattedMessage} from 'react-intl'
import WebDrawer from '../web-drawer'

const LongDescriptionModal = ({isOpen, onClose, product, isVariantSelected, variantId}) => {
    const {formatMessage} = useIntl()
    const displayProductId = isVariantSelected ? variantId : product?.id

    return (
        <WebDrawer
            isOpen={isOpen}
            onClose={onClose}
            title={formatMessage({
                defaultMessage: 'Product Details',
                id: 'product_detail.accordion.button.product_detail'
            })}
            size="85vh"
        >
            <Box textStyle="bodyXsRegular">
                {product?.longDescription ? (
                    <Box
                        sx={{
                            p: {marginBottom: 2},
                            ul: {marginTop: 1, marginBottom: 1, paddingLeft: 4},
                            li: {marginBottom: 1}
                        }}
                        dangerouslySetInnerHTML={{__html: product.longDescription}}
                    />
                ) : null}

                {displayProductId ? (
                    <Box sx={{marginTop: 4}}>
                        <Text textStyle="bodyXsRegular">
                            {isVariantSelected ? (
                                <FormattedMessage
                                    defaultMessage="Sku # {pid}"
                                    id="product_detail.accordion.sku"
                                    values={{pid: displayProductId}}
                                />
                            ) : (
                                <FormattedMessage
                                    defaultMessage="Style # {pid}"
                                    id="product_detail.accordion.style"
                                    values={{pid: displayProductId}}
                                />
                            )}
                        </Text>
                    </Box>
                ) : null}
            </Box>
        </WebDrawer>
    )
}

LongDescriptionModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    product: PropTypes.object,
    isVariantSelected: PropTypes.bool,
    variantId: PropTypes.string
}

export default LongDescriptionModal
